import api from '@/api'
import constants from '@/constants'

const REV_TYPES = Object.freeze([
  constants.exploreEntityTypes.improvementIdea,
  constants.exploreEntityTypes.problemSolving,
  constants.exploreEntityTypes.quickAction,
])

const getFiltersForRole = (role, accountId) => {
  if (role === constants.exploreRoleTypes.owner) return { owner: accountId }
  if (role === constants.exploreRoleTypes.coach) return { coach: accountId }
  if (role === constants.exploreRoleTypes.collaborators)
    return { collaborators: [accountId] }
  return {}
}

export default {
  async getProfile(context, { organizationId, accountId }) {
    const response = await api.account.getProfile(organizationId, accountId)
    return response.data
  },

  async getRevsByUserRole(
    context,
    { organizationId, role, accountId, options }
  ) {
    const response = await api.explore.getContent({
      organizationId,
      ...options,
      filters: { ...getFiltersForRole(role, accountId), types: REV_TYPES },
    })

    return {
      results: response.data.results.map(result => result.response),
      totalRecordsInData: response.data.totalRecordsInData,
    }
  },
}
